 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		9: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		9: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"2cca2479","2":"c16184b3","3":"commons","4":"7bfb1122f37a507b36af86fe1d3fb52f6c338fe0","5":"e355599075af3cf14ea9db4f74022774fc480444","6":"93d3eb3658759467b569ae36eccfacd1585c63ef","7":"9258e47e0fa139cd8fa80349670d8cafa40635bd","8":"0f56c722f5e6eeda167302276672613a218b37ca","13":"component---src-pages-404-js","14":"component---src-pages-about-js","15":"component---src-pages-articles-js","16":"component---src-pages-careers-js","17":"component---src-pages-contact-us-js","18":"component---src-pages-events-acm-mile-high-video-2025-js","19":"component---src-pages-events-anga-com-2023-witbe-automated-testing-technology-js","20":"component---src-pages-events-anga-com-2024-js","21":"component---src-pages-events-anga-com-2025-js","22":"component---src-pages-events-asia-video-summit-2024-js","23":"component---src-pages-events-atxsg-2023-witbe-in-singapore-monitoring-technology-js","24":"component---src-pages-events-atxsg-2024-js","25":"component---src-pages-events-atxsg-broadcast-asia-2025-js","26":"component---src-pages-events-broadcast-pro-summit-ksa-2025-js","27":"component---src-pages-events-cabsat-dubai-2025-js","28":"component---src-pages-events-canadian-independent-telecommunications-association-cita-2025-js","29":"component---src-pages-events-connected-tv-world-summit-2024-js","30":"component---src-pages-events-connected-tv-world-summit-2025-js","31":"component---src-pages-events-ibc-2023-monitoring-fast-channel-with-witbe-js","32":"component---src-pages-events-ibc-2024-js","33":"component---src-pages-events-js","34":"component---src-pages-events-meet-witbe-in-asia-video-summit-2023-testing-monitoring-js","35":"component---src-pages-events-nab-show-las-vegas-2024-js","36":"component---src-pages-events-nab-show-las-vegas-2025-js","37":"component---src-pages-events-nabshow-2023-witbe-proactive-monitoring-technology-js","38":"component---src-pages-events-nctc-winter-educational-conference-2025-js","39":"component---src-pages-events-plugfest-dtg-2025-js","40":"component---src-pages-events-scte-cable-tec-2023-witbe-fast-channel-testing-technology-js","41":"component---src-pages-events-scte-techexpo-2024-js","42":"component---src-pages-events-the-future-of-tv-advertising-sydney-2024-js","43":"component---src-pages-index-js","44":"component---src-pages-locations-js","45":"component---src-pages-policy-js","46":"component---src-pages-products-witbox-js","47":"component---src-pages-sitemap-js","48":"component---src-pages-tech-rewind-2023-js","49":"component---src-pages-tech-rewind-2024-js","50":"component---src-pages-technology-js","51":"component---src-pages-technology-qa-test-automation-js","52":"component---src-pages-technology-remote-device-access-js","53":"component---src-pages-technology-supported-devices-js","54":"component---src-pages-technology-video-service-monitoring-js","55":"component---src-pages-technology-vod-asset-checking-js","56":"component---src-templates-article-js","57":"component---src-templates-ghost-article-js","58":"e4aa109a"}[chunkId]||chunkId) + "-" + {"0":"407fe62976dc5310c43e","1":"ff3e12a7468c6324dbd0","2":"e5626c7824622008d673","3":"10836774afd43486e58a","4":"f045e02478f666fa0aac","5":"c6f521cc92efa4bcb6a4","6":"80e0bdb2e2cd15ed0273","7":"20bcacb058595d340be8","8":"b36529e375bb0f0440c7","10":"610e6d6fa9d8e525036d","13":"e59d48d207c6e638dd48","14":"14bee008bdbaa57ba79a","15":"1d1a30e648685425136a","16":"c997d54dcfc107b9aa9c","17":"a67629264285f45af10c","18":"f89a8faf10750f8e547b","19":"daebfd4ddaf2e1305f98","20":"164755a2d40d7deb8f50","21":"f8d3c183e4e1f1019a5e","22":"343313e053142f293573","23":"997b5ed15825c776e318","24":"ab51ac4430df3abe6bc4","25":"1a7bb99755ae4a1a99a1","26":"917ac33e6717f3d4b0d8","27":"cf4451bc5653d235f7d6","28":"aa0159275fce05d98a4e","29":"ce09c413cfc9966a4263","30":"f81fadd070376ad95631","31":"5181cf445e219e37893a","32":"548b56da8561eee0e974","33":"d6b6e5c270e7c5039afa","34":"aa8dcd9c88603d5e3481","35":"43b16277a80b5d976466","36":"54ec8b4a73e506019b0c","37":"e71a7b4039a08043fa90","38":"59d06578d366f7e0f555","39":"d88b128590ad51e290b4","40":"4af04b36506ce89cdc97","41":"024aff37d4490562b282","42":"464eab9cdb76830c4425","43":"5f85fa451b3112790098","44":"fe6ac3be1b1ca399de27","45":"f4b30b05aff5a3e8da8e","46":"14b2fe487ce3a9644952","47":"2bec65fc1f57a2355556","48":"9e1333e1af2d5fc97e78","49":"eb4d81bed3a4e3c1a09e","50":"d7117c5761be06a34b8d","51":"205c4a23bc5161a4b15d","52":"6189d84d0a1ad44dd313","53":"e8c4e811b543e4210ba5","54":"56a4a9ace9770186015e","55":"6ea490cfca55d9e9fcd7","56":"942f1e1645dffde2912c","57":"9385344781ee9824d3b2","58":"48dedba5543c28b253de","62":"1f3ca3ae374e727110ca","63":"a7a7a2975c9956df648b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"2cca2479","2":"c16184b3","3":"commons","4":"7bfb1122f37a507b36af86fe1d3fb52f6c338fe0","5":"e355599075af3cf14ea9db4f74022774fc480444","6":"93d3eb3658759467b569ae36eccfacd1585c63ef","7":"9258e47e0fa139cd8fa80349670d8cafa40635bd","8":"0f56c722f5e6eeda167302276672613a218b37ca","13":"component---src-pages-404-js","14":"component---src-pages-about-js","15":"component---src-pages-articles-js","16":"component---src-pages-careers-js","17":"component---src-pages-contact-us-js","18":"component---src-pages-events-acm-mile-high-video-2025-js","19":"component---src-pages-events-anga-com-2023-witbe-automated-testing-technology-js","20":"component---src-pages-events-anga-com-2024-js","21":"component---src-pages-events-anga-com-2025-js","22":"component---src-pages-events-asia-video-summit-2024-js","23":"component---src-pages-events-atxsg-2023-witbe-in-singapore-monitoring-technology-js","24":"component---src-pages-events-atxsg-2024-js","25":"component---src-pages-events-atxsg-broadcast-asia-2025-js","26":"component---src-pages-events-broadcast-pro-summit-ksa-2025-js","27":"component---src-pages-events-cabsat-dubai-2025-js","28":"component---src-pages-events-canadian-independent-telecommunications-association-cita-2025-js","29":"component---src-pages-events-connected-tv-world-summit-2024-js","30":"component---src-pages-events-connected-tv-world-summit-2025-js","31":"component---src-pages-events-ibc-2023-monitoring-fast-channel-with-witbe-js","32":"component---src-pages-events-ibc-2024-js","33":"component---src-pages-events-js","34":"component---src-pages-events-meet-witbe-in-asia-video-summit-2023-testing-monitoring-js","35":"component---src-pages-events-nab-show-las-vegas-2024-js","36":"component---src-pages-events-nab-show-las-vegas-2025-js","37":"component---src-pages-events-nabshow-2023-witbe-proactive-monitoring-technology-js","38":"component---src-pages-events-nctc-winter-educational-conference-2025-js","39":"component---src-pages-events-plugfest-dtg-2025-js","40":"component---src-pages-events-scte-cable-tec-2023-witbe-fast-channel-testing-technology-js","41":"component---src-pages-events-scte-techexpo-2024-js","42":"component---src-pages-events-the-future-of-tv-advertising-sydney-2024-js","43":"component---src-pages-index-js","44":"component---src-pages-locations-js","45":"component---src-pages-policy-js","46":"component---src-pages-products-witbox-js","47":"component---src-pages-sitemap-js","48":"component---src-pages-tech-rewind-2023-js","49":"component---src-pages-tech-rewind-2024-js","50":"component---src-pages-technology-js","51":"component---src-pages-technology-qa-test-automation-js","52":"component---src-pages-technology-remote-device-access-js","53":"component---src-pages-technology-supported-devices-js","54":"component---src-pages-technology-video-service-monitoring-js","55":"component---src-pages-technology-vod-asset-checking-js","56":"component---src-templates-article-js","57":"component---src-templates-ghost-article-js","58":"e4aa109a"}[chunkId]||chunkId) + "." + {"0":"175b01a4790e92992d82","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
